import React, { useState } from "react";
import { getFirestore, collection, orderBy, getDocs, limit, query, setDoc, doc } from "firebase/firestore";
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';

function AddServicio() {
    const [state, setState] = useState({
        name: '',
        type: 'check',
        order: '',
        hogar: '70000',
        feriado_domingo_hogar: '70000',
        unidad_medida: 'Unitario',
        montoFijo: false,
        montoFijoValor: '70000',
        montoFijoFeriadoValor: '70000',
        submitted: false,
        spinner: false,
    });

    const onChangeValues = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setState(prevState => ({ ...prevState, [name]: value }));
    };

    const saveServicioFirestore = async () => {
        const firestore = getFirestore();

        try {
            if (!state.name.trim()) {
                alert("Por favor ingrese el nombre del servicio");
                return;
            }

            setState(prevState => ({ ...prevState, spinner: true }));
            const serviciosColRef = collection(firestore, "servicios");

            // Buscar el mayor ID existente
            const q = query(serviciosColRef, orderBy("id", "desc"), limit(1));
            const querySnapshot = await getDocs(q);

            let lastId = -1;
            if (!querySnapshot.empty) {
                querySnapshot.forEach((docSnap) => {
                    const data = docSnap.data();
                    if (data.id !== undefined && typeof data.id === 'number') {
                        lastId = Math.max(lastId, data.id);
                    }
                });
            }

            const newId = lastId + 1;
            const newOrder = state.order !== '' ? parseInt(state.order, 10) : newId;

            // 1. Guardar en la colección 'servicios'
            const newServiceData = {
                id: newId,
                name: state.name.trim(),
                type: state.type,
                order: newOrder,
            };

            await setDoc(doc(firestore, "servicios", newId.toString()), newServiceData);

            // 2. Guardar en la colección 'precios'
            const newPriceData = {
                id: newId,
                descripcion: state.name.trim(),
                unidad_medida: state.unidad_medida || "Unitario",
                hogar: String(state.hogar || "0"),
                corporativo: "0",
                feriado_domingo_hogar: String(state.feriado_domingo_hogar || state.hogar || "0"),
                feriado_domingo_corporativo: "0",
                montoFijo: state.montoFijo === true,
                montoFijoValor: String(state.montoFijoValor || state.hogar || "0"),
                montoFijoFeriadoValor: String(state.montoFijoFeriadoValor || state.feriado_domingo_hogar || state.montoFijoValor || "0"),
            };

            await setDoc(doc(firestore, "precios", newId.toString()), newPriceData);

            setState(prevState => ({
                ...prevState,
                submitted: true,
                spinner: false
            }));

            console.log("Nuevo servicio y precio guardados con éxito con ID:", newId);
        } catch (error) {
            console.error("Error al guardar el servicio: ", error);
            setState(prevState => ({ ...prevState, spinner: false }));
        }
    };

    return (
        <Container component="main" maxWidth="md" sx={{ mt: 4, mb: 4 }}>
            {state.submitted ? (
                <div>
                    <Typography variant="h4" sx={{ mb: 2 }}>¡Servicio creado correctamente!</Typography>
                    <Button variant="contained" href="/servicios">
                        Ir a listado
                    </Button>
                </div>
            ) : (
                <div className="form-container">
                    {state.spinner ? (
                        <CircularProgress />
                    ) : (
                        <>
                            <Typography component="h1" variant="h5" sx={{ mb: 3 }}>
                                Nuevo Servicio
                            </Typography>
                            <div className="order-container">
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            id="name"
                                            label="Nombre del servicio"
                                            value={state.name}
                                            name="name"
                                            onChange={onChangeValues}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FormControl fullWidth variant="outlined">
                                            <InputLabel id="type-label">Tipo de Control</InputLabel>
                                            <Select
                                                labelId="type-label"
                                                id="type"
                                                name="type"
                                                value={state.type}
                                                onChange={onChangeValues}
                                                label="Tipo de Control"
                                            >
                                                <MenuItem value="check">Casilla de verificación (Check)</MenuItem>
                                                <MenuItem value="number">Numérico (Cantidad)</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <TextField
                                            variant="outlined"
                                            fullWidth
                                            id="order"
                                            label="Orden de visualización"
                                            type="number"
                                            value={state.order}
                                            name="order"
                                            onChange={onChangeValues}
                                            helperText="Dejar vacío para auto-asignar"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <TextField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            id="hogar"
                                            label="Precio Cliente Hogar (Gs.)"
                                            type="number"
                                            value={state.hogar}
                                            name="hogar"
                                            onChange={onChangeValues}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <TextField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            id="feriado_domingo_hogar"
                                            label="Precio Cliente Feriado/Domingo (Gs.)"
                                            type="number"
                                            value={state.feriado_domingo_hogar}
                                            name="feriado_domingo_hogar"
                                            onChange={onChangeValues}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={state.montoFijo}
                                                    onChange={(e) => setState(prev => ({
                                                        ...prev,
                                                        montoFijo: e.target.checked,
                                                        montoFijoValor: e.target.checked && !prev.montoFijoValor ? prev.hogar : prev.montoFijoValor,
                                                        montoFijoFeriadoValor: e.target.checked && !prev.montoFijoFeriadoValor ? (prev.feriado_domingo_hogar || prev.hogar) : prev.montoFijoFeriadoValor
                                                    }))}
                                                    color="primary"
                                                />
                                            }
                                            label="Activar Monto Fijo (Cuadrilla)"
                                        />
                                    </Grid>
                                    {state.montoFijo && (
                                        <>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    variant="outlined"
                                                    required
                                                    fullWidth
                                                    id="montoFijoValor"
                                                    label="Monto Fijo Semana (Gs.)"
                                                    type="number"
                                                    value={state.montoFijoValor}
                                                    name="montoFijoValor"
                                                    onChange={onChangeValues}
                                                    helperText="Monto en días hábiles que cobrará la cuadrilla por este servicio"
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    variant="outlined"
                                                    required
                                                    fullWidth
                                                    id="montoFijoFeriadoValor"
                                                    label="Monto Fijo Domingo / Feriado (Gs.)"
                                                    type="number"
                                                    value={state.montoFijoFeriadoValor}
                                                    name="montoFijoFeriadoValor"
                                                    onChange={onChangeValues}
                                                    helperText="Monto en domingos o feriados que cobrará la cuadrilla por este servicio"
                                                />
                                            </Grid>
                                        </>
                                    )}
                                </Grid>
                                <Button
                                    type="button"
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    className="button__save"
                                    onClick={saveServicioFirestore}
                                    sx={{ mt: 3 }}
                                >
                                    Guardar Servicio
                                </Button>
                            </div>
                        </>
                    )}
                </div>
            )}
        </Container>
    );
}

export default AddServicio;
